import { render } from "./PenIcon.vue?vue&type=template&id=22d26f10&scoped=true"
import script from "./PenIcon.vue?vue&type=script&lang=js"
export * from "./PenIcon.vue?vue&type=script&lang=js"

import "./PenIcon.vue?vue&type=style&index=0&id=22d26f10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d26f10"]])

export default __exports__